"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = ['name', 'question', 'description', 'completeCondition', 'minimumNumber', 'afterCompletion', 'shape', 'showItemAs', 'layoutType'];
exports.fields = fields;
var initialValues = {
  name: 'Menu',
  question: '',
  description: '',
  completeCondition: 'all',
  minimumNumber: 1,
  afterCompletion: 'return',
  shape: 'square',
  showItemAs: 'text',
  layoutType: 'grid'
};
exports.initialValues = initialValues;
var icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-cutlery"
});
exports.icon = icon;
var validate = function validate(values) {
  var errors = {};
  var completeCondition = values.completeCondition,
    afterCompletion = values.afterCompletion;
  if (completeCondition === 'none' && afterCompletion === 'advance') {
    errors.afterCompletion = 'You cannot auto advance when no menu options are required';
  }
  return errors;
};
exports.validate = validate;